import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';

import { MtnaSectionHeaderModule } from '@mtna/lib-ui';

import { RdsPackageBundleSelectionModule } from '../package-bundle-selection/index';
import { RdsPackageFormatSelectionModule } from '../package-format-selection/index';
import { RdsFormatSelectionDialogComponent } from './format-selection-dialog.component';

const COMPONENTS = [RdsFormatSelectionDialogComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatBadgeModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    MtnaSectionHeaderModule,
    RdsPackageBundleSelectionModule,
    RdsPackageFormatSelectionModule
  ],
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  entryComponents: [RdsFormatSelectionDialogComponent]
})
export class RdsPackageFormatSelectionDialogModule {}

export * from './format-selection-dialog.component';
